var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_tag",
    d: "M16.125,0H11.368A3.355,3.355,0,0,0,8.98.988L.64,9.33a2.185,2.185,0,0,0,0,3.09l4.941,4.941a2.185,2.185,0,0,0,3.089,0l8.341-8.341A3.352,3.352,0,0,0,18,6.632V1.875A1.877,1.877,0,0,0,16.125,0Zm-2.25,6A1.875,1.875,0,1,1,15.75,4.125,1.877,1.877,0,0,1,13.875,6Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_tag.f5e9d4b29302fcce91254eb475eebb4c.svg";